// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"sidepane_dimmer__30m_A","SlidePane":"sidepane_SlidePane__2GM15","right":"sidepane_right__3OXZa","header":"sidepane_header__9dBo6","body":"sidepane_body__2mFkD"};